import { Link, useLocation } from 'react-router-dom';
import { useState, useContext } from 'react';
import logoImage from '../assets/logo.png';
import Icon from './Icon';
import IymcsMark from './IymcsMark';
import { useTheme } from '../context/ThemeContext';
import { SiteContentContext } from '../context/SiteContentContext';
import '../styles/header.css';

const SunIcon = () => (
  <svg className="theme-toggle__icon theme-toggle__icon--sun" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="5"/>
    <line x1="12" y1="1" x2="12" y2="3"/>
    <line x1="12" y1="21" x2="12" y2="23"/>
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
    <line x1="1" y1="12" x2="3" y2="12"/>
    <line x1="21" y1="12" x2="23" y2="12"/>
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
  </svg>
);

const MoonIcon = () => (
  <svg className="theme-toggle__icon theme-toggle__icon--moon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
  </svg>
);

const ABOUT_LINKS = [
  { to: '/team',    label: 'Команда',            icon: 'people' },
  { to: '/fleet',   label: 'Флот',               icon: 'sail' },
  { to: '/iymcs',   label: <IymcsMark capitalize />, icon: 'certificate' },
  { to: '/pricing', label: 'О ценах',           icon: 'money' },
  { to: '/faq',     label: 'Вопросы и ответы',  icon: 'compass' },
  { to: '/packing', label: 'Что взять с собой', icon: 'flag' },
  { to: '/info',    label: 'Контакты',           icon: 'phone' },
];

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [mobileAboutOpen, setMobileAboutOpen] = useState(false);
  const location = useLocation();
  const { dark, toggle } = useTheme();
  const { content } = useContext(SiteContentContext);
  const isPreview = location.pathname.startsWith('/preview');
  const p = (path) => isPreview ? `/preview${path}` : path;

  const closeMenu = () => { setIsMenuOpen(false); setMobileAboutOpen(false); };

  return (
    <header className="app-header">
      <div className="header-container">
        <Link to={p('/')} className="logo-link">
          <img src={logoImage} alt="logo" style={{ width: '40px', margin: '0 20px' }} />
          <div className="logo-text">
            <span className="logo-title">{content?.schoolName || 'Dr. Sailing'}</span>
            <span className="logo-subtitle">{content?.schoolSubtitle || 'Парусная школа'}</span>
          </div>
        </Link>

        <nav className="main-nav">
          <ul className="nav-list">
            <li className="nav-item">
              <Link to={p('/adventures')} className="nav-link">Путешествия</Link>
            </li>
            <li className="nav-item">
              <Link to={p('/study')} className="nav-link">Обучение яхтингу</Link>
            </li>
            <li className="nav-item">
              <Link to={p('/races')} className="nav-link">Регаты</Link>
            </li>

            {/* Dropdown «О нас» */}
            <li className="nav-item nav-dropdown">
              <button className="nav-link nav-dropdown-trigger">
                О нас <svg className="nav-arrow" viewBox="0 0 10 6" width="10" height="6" fill="currentColor"><path d="M0 0l5 6 5-6z"/></svg>
              </button>
              <div className="nav-dropdown-menu">
                {ABOUT_LINKS.map(l => (
                  <Link key={l.to} to={p(l.to)} className="nav-dropdown-item">
                    <Icon name={l.icon} size={16} color="#db782e" />
                    {l.label}
                  </Link>
                ))}
              </div>
            </li>

            <li style={{ marginLeft: 16 }}>
              <button
                onClick={toggle}
                title={dark ? 'Светлая тема' : 'Тёмная тема'}
                className={`theme-toggle ${dark ? 'theme-toggle--dark' : ''}`}
                aria-label={dark ? 'Светлая тема' : 'Тёмная тема'}
              >
                <SunIcon />
                <span className="theme-toggle__track">
                  <span className="theme-toggle__thumb" />
                </span>
                <MoonIcon />
              </button>
            </li>

            <li className="schedule-btn">
              <Link to={p('/schedule')}>Записаться</Link>
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path fill="currentColor" d="M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z"/>
              </svg>
            </li>

          </ul>
        </nav>

        <button
          onClick={toggle}
          className={`theme-toggle theme-toggle--mobile-header ${dark ? 'theme-toggle--dark' : ''}`}
          aria-label={dark ? 'Светлая тема' : 'Тёмная тема'}
        >
          <SunIcon />
          <span className="theme-toggle__track">
            <span className="theme-toggle__thumb" />
          </span>
          <MoonIcon />
        </button>

        <button
          className="mobile-menu-button"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Меню"
        >
          <span className={`menu-line ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`menu-line ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`menu-line ${isMenuOpen ? 'open' : ''}`}></span>
        </button>
      </div>

      {/* Mobile nav */}
      <div className={`mobile-nav ${isMenuOpen ? 'open' : ''}`}>
        <ul className="mobile-nav-list">
          <li className="nav-item">
            <Link to={p('/adventures')} className="nav-link" onClick={closeMenu}>Путешествия</Link>
          </li>
          <li className="nav-item">
            <Link to={p('/study')} className="nav-link" onClick={closeMenu}>Обучение яхтингу</Link>
          </li>
          <li className="nav-item">
            <Link to={p('/races')} className="nav-link" onClick={closeMenu}>Регаты</Link>
          </li>
          <li className="nav-item mobile-about">
            <button
              className="nav-link mobile-about-btn"
              onClick={() => setMobileAboutOpen(p => !p)}
            >
              О нас <svg className="nav-arrow" viewBox="0 0 10 6" width="12" height="12" fill="currentColor" style={{ transform: mobileAboutOpen ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}><path d="M0 0l5 6 5-6z"/></svg>
            </button>
            {mobileAboutOpen && (
              <ul className="mobile-submenu">
                {ABOUT_LINKS.map(l => (
                  <li key={l.to}>
                    <Link to={p(l.to)} className="mobile-submenu-link" onClick={closeMenu}>
                      <Icon name={l.icon} size={16} color="#db782e" />
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
          <li className="nav-item">
            <Link to={p('/schedule')} className="nav-link" onClick={closeMenu}>Записаться</Link>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Header;


